/*
 *                     NOTICE
 *            COPYRIGHT 2022 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

let TEST_CURRENT_DATE = null;

/** Factory method to return now(), but tests can override returned value via the setTestDate method */
export function getCurrentDate() {
  return TEST_CURRENT_DATE ?? new Date();
}
export function setTestDate(val) {
  // Part of the 'resetStatic' workflow via as DateTimeUtils.resetStatics invokes setTestDate(null)
  TEST_CURRENT_DATE = val;
}
//# sourceMappingURL=CurrentDateFactory.js.map
